module.exports = __webpack_public_path__ + "img/violet_130.39dd7bc0.png";